import { render } from "./FooterAtom.vue?vue&type=template&id=2ea0dabc&scoped=true"
import script from "./FooterAtom.vue?vue&type=script&lang=js"
export * from "./FooterAtom.vue?vue&type=script&lang=js"

import "./FooterAtom.vue?vue&type=style&index=0&id=2ea0dabc&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea0dabc"]])

export default __exports__